<p-toast
  position="bottom-right"
  class="[&_.p-toast-message-content]:items-center [&_.p-toast-message-text]:block [&_.p-toast-summary]:text-sm [&_.p-toast]:max-w-[70%]"
></p-toast>
<p-confirmDialog />
<router-outlet />
